import api from "@/api.js";
import units from "./units";
import data from "./data/";
import emissionsFactor from "./emissionsFactor";
import solutions from "./solutions";
import scale from "./scale";

export default {
  modules: {
    units,
    data,
    emissionsFactor,
    solutions,
    scale,
  },
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    selectedSource: null,
    selectedSourceData: null,
    sourcesOutcomesList: [],
    sourcesWithData: [],
    sourcesWithDataLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedSource(state, payload) {
      state.selectedSource = payload;
    },
    setSourcesOutcomesList(state, payload) {
      state.sourcesOutcomesList = payload;
    },
    setSelectedSourceData(state, payload) {
      state.selectedSourceData = payload;
    },
    setSourcesWithData(state, payload) {
      state.sourcesWithData = payload;
    },
    setSourcesWithDataLoading(state, payload) {
      state.sourcesWithDataLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("sources");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllForSection({ commit }, payload) {
      commit("setListLoading", true);
      let list = await api.get("sources/forSection", {
        params: { id: payload },
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadSourceByID({ commit }, id) {
      let source = await api.get("sources/byID", { params: { id: id } });
      if (source.data.length > 0) {
        commit("setSelectedSource", source.data[0]);
      }
    },
    async loadAllWithData({ commit }, params = null) {
      commit("setSourcesWithDataLoading", true);
      let list = await api.get("sources/withData", { params: params });
      commit("setSourcesWithData", list.data);
      commit("setSourcesWithDataLoading", false);
    },
    async loadSourcesByOutcomeID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("sourcesOutcomes/byOutcomeID", {
        params: { id: id },
      });
      commit("setSourcesOutcomesList", list.data);
      commit("setListLoading", false);
    },
    async loadSourcesDataByID({ commit }, id) {
      let list = await api.get("sourcesData/byID", { params: { id: id } });
      commit("setSelectedSourceData", list.data[0]);
    },
    async loadUnknownSourceByOutcomeID({ commit }, id) {
      let list = await api.get("/source/unknown/byOutcomeID", {
        params: { id: id },
      });
      commit("setSelectedSource", list.data[0]);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/sources", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async newSourcesCategory({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/outcomesCategories", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadSourcesByOutcomeID", payload.outcomes_id);
      return returnData;
    },
    async newSourcesOutcomes({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/sourcesOutcomes", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadSourcesByOutcomeID", payload.outcomes_id);
      return returnData;
    },
    async newSourcesData({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/sourcesData", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });

      return returnData;
    },
    async saveSourcesData({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/sourcesData", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });

      return returnData;
    },
    async saveSourcesCategory({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/outcomesCategories", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadSourcesByOutcomeID", payload.outcomes_id);
      return returnData;
    },
    async saveSourcesOutcomes({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("/sourcesOutcomes", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadSourcesByOutcomeID", payload.outcomes_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      //Uploading Image
      if (payload.imageUrl) {
        let uploadImageResult = await api.post("sources/uploadSourceImage", {
          id: payload.id,
          imageData: payload.imageUrl.dataUrl,
        });
        delete payload.imageUrl;
        if (uploadImageResult.data.Result == "Success") {
          payload.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      await api
        .put(`sources`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`sources/delete`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      // dispatch("loadAll");
      return returnData;
    },
    async createPositiveAlternative({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`sources/createPositiveAlternative`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedSource(state) {
      return state.selectedSource;
    },
    sourcesOutcomesList(state) {
      return state.sourcesOutcomesList;
    },
    sourcesOutcomesListOrdered(state) {
      return state.sourcesOutcomesList.sort((a, b) => {
        if (!a.sourceName) {
          return 1;
        } else if (!b.sourceName) {
          return -1;
        }

        return a.sourceName.toLowerCase() < b.sourceName.toLowerCase()
          ? -1
          : b.sourceName.toLowerCase() > a.sourceName.toLowerCase()
          ? 1
          : 0;
      });
    },
    selectedSourceData(state) {
      return state.selectedSourceData;
    },
    sourcesWithData(state) {
      return state.sourcesWithData;
    },
    sourcesWithDataLoading(state) {
      return state.sourcesWithDataLoading;
    },
  },
};
